<template>
    <facet-template
        :show-clear-link="isFiltered"
        :title="title"
        v-bind="$attrs"
        @clear="clearSelectedTransmissions"
    >
      <span slot="facetLabel">
            {{ title }}
            <small class="font-italic font-weight-normal" v-if="value.length>0">
                ({{ value.length }})
            </small>
        </span>
        <b-container>
            <b-row>
                <b-col cols="12" class="p-0 mb-0">
                    <div
                        class="d-flex flex-row justify-content-around flex-wrap"
                    >
                        <div
                            v-for="transmission in filterableTransmissions"
                            :key="transmission.id"
                        >
                            <transmission-icon
                                :transmission="transmission"
                                :selected="isTransmissionSelected(transmission)"
                                @click.native="toggleTransmission(transmission)"
                            />
                        </div>
                    </div>
                </b-col>
            </b-row>
        </b-container>
    </facet-template>
</template>

<script>
import FacetTemplate from "./FacetTemplate";
import TransmissionIcon from "./components/TransmissionIcon";
import _ from "lodash";

export default {
    name: "TransmissionFacet",

    components: {
        FacetTemplate,
        TransmissionIcon
    },

    props: {
        value: {
            type: Array,
            required: true
        },
        available: {
            type: Array,
            required: true
        },
        title: {
            type: String,
            required: true
        }
    },

    computed: {
        /* Dont show "UNKNOWN" transmission facet. It will always be appended server side */
        filterableTransmissions() {
            return this.available.filter(
                transmission => transmission.name !== "UNKNOWN"
            );
        },
        isFiltered() {
            return !_.isEmpty(this.value);
        }
    },

    methods: {
        clearSelectedTransmissions() {
            this.$emit("input", []);
        },
        toggleTransmission(transmission) {
            const transmissionIsAlreadySelected = this.isTransmissionSelected(
                transmission
            );

            if (transmissionIsAlreadySelected) {
                this.removeTransmissionFromFilters(transmission);
            } else {
                this.addTransmissionToFilters(transmission);
            }
        },
        addTransmissionToFilters(transmission) {
            this.$emit("input", this.value.concat(transmission.name));
        },
        removeTransmissionFromFilters(transmission) {
            this.$emit(
                "input",
                this.value.filter(
                    transmissionName => transmissionName !== transmission.name
                )
            );
        },
        isTransmissionSelected(transmission) {
            return _.includes(this.value, transmission.name);
        }
    }
};
</script>
